import {
  Button,
  DatePicker,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";

const MerchantCreateCustomer = ({
  open,
  close,
  setLoading,
  getMerchantOrderSaveList,
  activeServiceList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [selectedService, setSelectedService] = useState(null);
  //   const [selectedType, setSelectedType] = useState(null);
  //   const ages = [3, 33, 16, 40];
  const [form] = Form.useForm();

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedBooked, setSelectedBooked] = useState(null);
  const [selectedBookedCategory, setSelectedBookedCategory] = useState(null);

  // console.log(
  //   "selectedService: ",
  //   (userData.data.perproductcost.percentage / 100) * selectedService.srp
  // );

  const handleAvailToService = (values) => {
    const formdata = new FormData();
    formdata.append("down_cashier_id", userData.data.id);
    formdata.append("user_id", userData.data.id);
    formdata.append("service_type", selectedService.service_type);
    formdata.append(
      "service_duration_unit",
      selectedService.service_type === "duration"
        ? selectedService.service_duration
        : ""
    );
    formdata.append(
      "consumable_qty",
      selectedService.service_type === "consumable" ? 1 : ""
    );
    formdata.append("table_no", selectedService.service);
    formdata.append("description", selectedService.service_desc);
    formdata.append("price", selectedService.srp);
    formdata.append("transaction_id", Math.floor(Math.random() * 99999999) + 1);
    formdata.append(
      "final_started_date",
      moment(new Date(values.started_date)).format("YYYY-MM-DD HH:mm")
    );
    formdata.append(
      "ended_date",
      moment(new Date(values.started_date))
        .add(
          values.service_duration,
          selectedService.service_duration === "hour"
            ? "hours"
            : selectedService.service_duration === "day"
            ? "days"
            : "months"
        )
        .format("YYYY-MM-DD HH:mm")
    );
    formdata.append("payment_method", "cash");
    formdata.append(
      "cost_per_prod",
      userData.data.perproductcost !== null
        ? parseInt(selectedService.service_charge_exempted) !== 1
          ? (userData.data.perproductcost.percentage / 100) *
            selectedService.srp
          : 0
        : 0
    );
    formdata.append(
      "allow_housekeeping",
      userData.data.usersmerpermission.find(
        ({ permission }) => permission === "allow-house-keeping"
      )
        ? "yes"
        : "no"
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/new-avail-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved avail to service successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Avail The Service"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="create-avail-services1"
        initialValues={{
          service_desc: "",
        }}
        onFinish={handleAvailToService}
        autoComplete="off"
        form={form}
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="service"
            label="Service Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            {/* {console.log("activeServiceList", activeServiceList)} */}
            <Select
              placeholder="Select"
              size="large"
              onChange={(e) => {
                const value = activeServiceList.data.filter(
                  (res) => res.id === e
                );
                setSelectedService(value[0]);

                setSelectedBooked(null);
                setSelectedBookedCategory(null);
                setSelectedMethod(null);

                form.setFieldsValue({
                  is_booked: null,
                  booked_category: null,
                  downpayment_method: null,

                  edown_noncash: null,
                  downpayment: null,
                  edownpayment: null,
                  edown_ref_no: null,
                });
              }}
            >
              {activeServiceList.data.map((data, index) => (
                <Select.Option value={data.id} key={index}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    {userData.data.usersmerpermission.find(
                      ({ permission }) => permission === "allow-house-keeping"
                    ) && data.service_type !== "one-time" ? (
                      <div
                        style={{
                          width: 10,
                          height: 10,
                          backgroundColor:
                            data.service_status_abbreviation === "VR"
                              ? "green"
                              : data.service_status_abbreviation === "VC"
                              ? "orange"
                              : data.service_status_abbreviation === "VD"
                              ? "red"
                              : "gray",
                          marginRight: 5,
                          borderRadius: 5,
                        }}
                      />
                    ) : null}
                    {data.service_type === "consumable"
                      ? `${data.service} - ${data.srp}`
                      : data.service_type === "duration"
                      ? `${data.service} - ${data.srp}/${data.service_duration}`
                      : `${data.service} - ${data.srp}/person`}
                  </span>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="customer_name"
            label="Customer Name"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set Customer Name" size="large" />
          </Form.Item>

          {selectedService !== null &&
            selectedService.service_type !== "one-time" && (
              <Form.Item
                name="is_booked"
                label="Is Booked?"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select"
                  size="large"
                  onChange={(e) => {
                    setSelectedBooked(e);
                  }}
                >
                  <Select.Option value={1}>Yes</Select.Option>
                  <Select.Option value={0}>No</Select.Option>
                </Select>
              </Form.Item>
            )}

          {parseInt(selectedBooked) === 1 &&
            selectedService !== null &&
            selectedService.service_type !== "one-time" && (
              <>
                <Form.Item
                  name="booked_category"
                  label="Booked Category"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    size="large"
                    onChange={(e) => {
                      setSelectedBookedCategory(e);
                    }}
                  >
                    <Select.Option value={"pencil-booking"}>
                      Pencil Booking
                    </Select.Option>
                    <Select.Option value={"booking"}>Booking</Select.Option>
                  </Select>
                </Form.Item>

                {selectedBookedCategory === "booking" && (
                  <>
                    <Form.Item
                      name="downpayment_method"
                      label="Downpayment Method"
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select method"
                        onChange={(e) => {
                          setSelectedMethod(e);
                          // setInputtedPayment(null);
                          // setInputtedEcashPayment(null);
                          form.setFieldsValue({
                            edown_noncash: null,
                            downpayment: null,
                            edownpayment: null,
                            edown_ref_no: null,
                          });
                        }}
                        size="large"
                        showSearch
                      >
                        <Select.Option value={"enter-payment"}>
                          Cash Downpayment
                        </Select.Option>
                        <Select.Option value={"ecash-payment"}>
                          ECash Downpayment
                        </Select.Option>
                        <Select.Option value={"split-payment"}>
                          Split Downpayment
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    {selectedMethod === "enter-payment" && (
                      <Form.Item
                        name="downpayment"
                        label="Cash Amount"
                        rules={[
                          {
                            required: true,
                            message: "Required",
                          },
                        ]}
                      >
                        <InputNumber
                          min={1}
                          max={999999999999}
                          initialvalues={0}
                          size="large"
                          style={{ width: "100%" }}
                          step="0.01"
                          // onChange={(value) => setInputtedPayment(value)}
                        />
                      </Form.Item>
                    )}

                    {selectedMethod === "ecash-payment" && (
                      <>
                        <Form.Item
                          name="edown_noncash"
                          label="Non-cash"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select non-cash"
                            onChange={(e) => {
                              // setInputtedPayment(null);
                              // setInputtedEcashPayment(null);
                              form.setFieldsValue({
                                downpayment: null,
                                edownpayment: null,
                                edown_ref_no: null,
                              });
                            }}
                            size="large"
                            showSearch
                          >
                            <Select.Option value={"gcash"}>GCash</Select.Option>
                            <Select.Option value={"gcredit"}>
                              GCredit
                            </Select.Option>
                            <Select.Option value={"paymaya"}>
                              Paymaya
                            </Select.Option>
                            <Select.Option value={"creditcard"}>
                              Credit Card
                            </Select.Option>
                            <Select.Option value={"debitcard"}>
                              Debit Card
                            </Select.Option>
                            <Select.Option value={"banktransfer"}>
                              Bank Transfer
                            </Select.Option>
                            <Select.Option value={"cheque"}>
                              Cheque
                            </Select.Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="edownpayment"
                          label="ECash Amount"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={999999999999}
                            initialvalues={0}
                            size="large"
                            style={{ width: "100%" }}
                            step="0.01"
                            // onChange={(value) => setInputtedEcashPayment(value)}
                          />
                        </Form.Item>

                        <Form.Item
                          name="edown_ref_no"
                          label="Reference #"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Input placeholder="Set ref no" size="large" />
                        </Form.Item>
                      </>
                    )}

                    {selectedMethod === "split-payment" && (
                      <>
                        <Form.Item
                          name="downpayment"
                          label="Cash Amount"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={999999999999}
                            initialvalues={0}
                            size="large"
                            style={{ width: "100%" }}
                            step="0.01"
                            // onChange={(value) => setInputtedPayment(value)}
                          />
                        </Form.Item>

                        <Form.Item
                          name="edown_noncash"
                          label="Non-cash"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select non-cash"
                            onChange={(e) => {
                              // setSelectedMethod(e);
                              // setInputtedPayment(null);
                              // setInputtedEcashPayment(null);
                              form.setFieldsValue({
                                downpayment: null,
                                edownpayment: null,
                                edown_ref_no: null,
                              });
                            }}
                            size="large"
                            showSearch
                          >
                            <Select.Option value={"gcash"}>GCash</Select.Option>
                            <Select.Option value={"gcredit"}>
                              GCredit
                            </Select.Option>
                            <Select.Option value={"paymaya"}>
                              Paymaya
                            </Select.Option>
                            <Select.Option value={"creditcard"}>
                              Credit Card
                            </Select.Option>
                            <Select.Option value={"debitcard"}>
                              Debit Card
                            </Select.Option>
                            <Select.Option value={"banktransfer"}>
                              Bank Transfer
                            </Select.Option>
                            <Select.Option value={"cheque"}>
                              Cheque
                            </Select.Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          name="edownpayment"
                          label="ECash Amount"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <InputNumber
                            min={1}
                            max={999999999999}
                            initialvalues={0}
                            size="large"
                            style={{ width: "100%" }}
                            step="0.01"
                            // onChange={(value) => setInputtedEcashPayment(value)}
                          />
                        </Form.Item>

                        <Form.Item
                          name="edown_ref_no"
                          label="Reference #"
                          rules={[
                            {
                              required: true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Input placeholder="Set ref no" size="large" />
                        </Form.Item>
                      </>
                    )}
                  </>
                )}
              </>
            )}

          {selectedService !== null &&
          selectedService.service_type === "duration" ? (
            <Form.Item
              name="service_duration"
              label={`How Many ${selectedService.service_duration}(s)`}
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={1}
                size="large"
                style={{ width: "100%" }}
                step="1"
              />
            </Form.Item>
          ) : selectedService !== null &&
            selectedService.service_type === "one-time" ? (
            <Form.Item
              name="service_duration"
              label={`How Many Person(s)`}
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={1}
                size="large"
                style={{ width: "100%" }}
                step="1"
              />
            </Form.Item>
          ) : null}

          <Form.Item
            name="started_date"
            label="Date/Time Start"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"YYYY-MM-DD HH:mm"}
              size="large"
              style={{ width: "100%" }}
              showTime
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantCreateCustomer;
